import type { TraceDirection } from "./useNetworkTrace.ts";
import { useT } from "../i18n/hooks.ts";
import { ToolsMenuIcon } from "./ToolsMenuIcon.tsx";
import { TraceUpstreamIcon } from "./TraceUpstreamIcon.tsx";
import { TraceDownstreamIcon } from "./TraceDownstreamIcon.tsx";
import { DropdownMenu, DropdownMenuItem } from "./DropdownMenu.tsx";

/**
 * The ToolRail's own "Herramientas" menu — retired in a prior audit pass
 * when trace-upstream/downstream (its only two items) moved to the
 * PropertyPanel's contextual action row for an already-selected node,
 * leaving this slot empty. Brought back deliberately: Néstor wants a
 * standing "more tools live here" slot in the rail for future additions,
 * not just the panel-only shortcut — and, since a picked start node is
 * genuinely useful before selecting anything (the older pick-a-node-on-
 * the-map flow, `useNetworkTrace.ts`'s own `startPick`, was kept wired end
 * to end the whole time even with nothing left to trigger it from), the
 * same two trace actions live in both places rather than choosing one.
 */
export function ToolsMenu({
  onStartTrace,
  open,
  onToggle,
  onClose,
}: {
  onStartTrace: (direction: TraceDirection) => void;
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
}) {
  const t = useT();

  return (
    <DropdownMenu
      open={open}
      onToggle={onToggle}
      onClose={onClose}
      align="left"
      triggerClassName="tool-rail-button dropdown-trigger"
      triggerLabel={t("toolbar.tools")}
      triggerIcon={<ToolsMenuIcon />}
    >
      <DropdownMenuItem
        icon={<TraceUpstreamIcon />}
        label={t("networkTrace.traceUpstream")}
        onClick={() => {
          onClose();
          onStartTrace("upstream");
        }}
      />
      <DropdownMenuItem
        icon={<TraceDownstreamIcon />}
        label={t("networkTrace.traceDownstream")}
        onClick={() => {
          onClose();
          onStartTrace("downstream");
        }}
      />
    </DropdownMenu>
  );
}
